import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import API from "../api";
import {
  Button,
  Alert,
  Spinner,
  Card,
  Badge,
  Modal,
  Form,
  Row,
  Col,
} from "react-bootstrap";

const Dashboard = () => {
  const { user, setUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [courses, setCourses] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newLeagueData, setNewLeagueData] = useState({
    name: "",
    description: "",
    course: "",
    day: "",
    startdate: "",
    starttime: "",
    endtime: "",
    hdcp_pct: "",
    hdcp_max_up: "",
    hdcp_max_down: "",
    hasPosRnd: false,
    finalfunday: false,
    maxHDCP: "",
    teamcount: "",
    isActive: false,
    shotgun: false,
  });

  useEffect(() => {
    const refreshUser = async () => {
      try {
        const { data } = await API.get("/auth/me");
        setUser(data);
      } catch (err) {
        console.error("Failed to load user:", err);
      } finally {
        setLoading(false);
      }
    };

    refreshUser();
  }, [setUser]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const { data } = await API.get("/courses/");
        setCourses(data);
      } catch (err) {
        console.error("Failed to load courses:", err);
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    if (user?.league) {
      setFormData({
        id: user.league.id,
        name: user.league.name || "",
        description: user.league.description || "",
        course: user.league.course?.id || "",
        day: user.league.day || "",
        startdate: user.league.startdate?.slice(0, 10) || "",
        starttime: user.league.starttime || "",
        endtime: user.league.endtime || "",
        teamcount: user.league.teamcount || 2, // still used, but will be locked
        secretaryname: user.league.secretaryname || "",
        secretaryphone: user.league.secretaryphone || "",
        secretaryemail: user.league.secretaryemail || "",
        hdcp_pct: user.league.hdcp_pct || 55,
        hdcp_max_up: user.league.hdcp_max_up || 1,
        hdcp_max_down: user.league.hdcp_max_down || 1,
        maxHDCP: user.league.maxHDCP || 5,
        isActive: user.league.isActive === true,
        hasPosRnd: user.league.hasPosRnd === true,       // allows 1, '1', true
        finalfunday: user.league.finalfunday === true,
        shotgun: user.league.shotgun === true,
      });
    }
  }, [user]);
  

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleNewInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewLeagueData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddLeague = async (e) => {
    e.preventDefault();
    try {
      await API.post("/league/add", newLeagueData);
      alert("League created successfully!");
      setShowAddModal(false);
      window.location.reload();
    } catch (err) {
      console.error("Error creating league:", err);
      alert("Failed to create league.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post("/league/update", formData);
      alert("League details updated successfully!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error("Error updating league:", err);
      alert("Failed to update league.");
    }
  };

  if (loading) return <Spinner animation="border" className="m-5" />;

  return (
    <div className="container mt-4">
      
      {!user?.is_paid && !user?.league && (
        <div className="mt-4">
          <Alert variant="warning">
            <p>You must purchase a license before you can create/manage a league.</p>
            <Button variant="primary" onClick={() => window.location.href = "/buy"}>Purchase License</Button>
          </Alert>
        </div>
      )}
      {user?.is_paid && !user?.league && (
        <div className="mt-4">
          <Button variant="success" onClick={() => setShowAddModal(true)}>Create League</Button>
        </div>
      )}
      {user?.league && (
        <>
          <Card className="mt-4">
  <Card.Body>
    <Card.Title><h2>League Overview</h2></Card.Title>

    <hr />
    <Row>
      <Col xs={12} md={6}>
        <p><strong>Name:</strong> {user.league?.name} League</p>
        <p><strong>Course:</strong> {user.league.course.name}</p>
        <p><strong>Day:</strong> {user.league.day}</p>
        <p><strong>Start Date:</strong> {new Date(user.league.startdate).toLocaleDateString()}</p>
        <p><strong>Start Time:</strong> {user.league.starttime}</p>
        <p><strong>End Time:</strong> {user.league.endtime}</p>
      </Col>
      <Col xs={12} md={6}>
        <p><strong>Team Count:</strong> {user.league.teamcount}</p>
        <p><strong>Max HDCP:</strong> {user.league.maxHDCP}</p>
        <p><strong>Max HDCP Up:</strong> {user.league.hdcp_max_up}</p>
        <p><strong>Max HDCP Down:</strong> {user.league.hdcp_max_down}</p>
        <p><strong>HDCP %:</strong> {user.league.hdcp_pct}%</p>
        
      </Col>
    </Row>

    <hr />
    <h6>Secretary Info</h6>
    <p><strong>Name:</strong> {user.league.secretaryname}</p>
    <p><strong>Phone:</strong> {user.league.secretaryphone}</p>
    <p><strong>Email:</strong> {user.league.secretaryemail}</p>

    <hr />
    <h6>League Settings</h6>
    <p>
      <strong>Position Round:</strong>{" "}
      {user.league.hasPosRnd ? <Badge bg="success">Yes</Badge> : <Badge bg="danger">No</Badge>}
    </p>
    <p>
      <strong>Final Funday:</strong>{" "}
      {user.league.finalfunday ? <Badge bg="success">Yes</Badge> : <Badge bg="danger">No</Badge>}
    </p>
    <p>
      <strong>Active:</strong>{" "}
      {user.league.isActive ? <Badge bg="success">Yes</Badge> : <Badge bg="danger">No</Badge>}
    </p>
    <p>
      <strong>Shotgun Start:</strong> {" "}
      {user.league.shotgun ? <Badge bg="success">Yes</Badge> : <Badge bg="danger">No</Badge>}
    </p>

    {(user.role === 2 || user.role === 3) && (
      <div className="text-end mt-3">
        <Button variant="primary" onClick={() => setShowModal(true)}>
          Edit League
        </Button>
      </div>
    )}
  </Card.Body>
</Card>

          {/* Edit League Modal */}
          <Modal show={showModal} onHide={() => setShowModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Edit League Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>League Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <Form.Select
              name="course"
              value={formData.course}
              onChange={handleInputChange}
              required
            >
              <option value="">Select a course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Day</Form.Label>
            <Form.Control
              as="select"
              name="day"
              value={formData.day}
              onChange={handleInputChange}
              required
            >
              <option value="">Choose a day</option>
              {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(day => (
                <option key={day} value={day}>{day}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Secretary Name</Form.Label>
            <Form.Control
              type="text"
              name="secretaryname"
              value={formData.secretaryname || ""}
              onChange={handleInputChange}
              required
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Secretary Phone</Form.Label>
            <Form.Control
              type="tel"
              name="secretaryphone"
              value={formData.secretaryphone || ""}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Form.Group className="mb-3">
            <Form.Label>Secretary Email</Form.Label>
            <Form.Control
              type="email"
              name="secretaryemail"
              value={formData.secretaryemail || ""}
              onChange={handleInputChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              name="startdate"
              value={formData.startdate}
              onChange={handleInputChange}
              required
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
        <Form.Group className="mb-3">
  <Form.Label>Team Count</Form.Label>
  <Form.Control
    type="number"
    name="teamcount"
    value={formData.teamcount}
    disabled
  />
  <Form.Text className="text-danger">
    Team count cannot be changed, contact us if you need to.
  </Form.Text>
</Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Start Time</Form.Label>
            <Form.Control
              type="text"
              name="starttime"
              value={formData.starttime}
              onChange={handleInputChange}
              required
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>End Time</Form.Label>
            <Form.Control
              type="text"
              name="endtime"
              value={formData.endtime}
              onChange={handleInputChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Handicap Percentage</Form.Label>
            <Form.Select
              name="hdcp_pct"
              value={formData.hdcp_pct}
              onChange={handleInputChange}
              required
            >
              <option value="">Select HDCP %</option>
              {Array.from({ length: 10 }, (_, i) => {
                const value = 55 + i * 5;
                return (
                  <option key={value} value={value}>
                    {value}%
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Max Handicap</Form.Label>
            <Form.Select
              name="maxHDCP"
              value={formData.maxHDCP}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Max Handicap</option>
              {Array.from({ length: 21 }, (_, i) => (
                <option key={i} value={i + 5}>
                  {i + 5}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Max Handicap Up</Form.Label>
            <Form.Select
              name="hdcp_max_up"
              value={formData.hdcp_max_up}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Max Up</option>
              {Array.from({ length: 5 }, (_, i) => (
                <option key={i} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Max Handicap Down</Form.Label>
            <Form.Select
              name="hdcp_max_down"
              value={formData.hdcp_max_down}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Max Down</option>
              {Array.from({ length: 5 }, (_, i) => (
                <option key={i} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Form.Check
            type="checkbox"
            name="isActive"
            label="Is Active?"
            checked={formData.isActive}
            onChange={handleInputChange}
          />
          <Form.Check
            type="checkbox"
            name="hasPosRnd"
            label="Has Position Round?"
            checked={formData.hasPosRnd}
            onChange={handleInputChange}
          />
          <Form.Check
            type="checkbox"
            name="finalfunday"
            label="Final Funday?"
            checked={formData.finalfunday}
            onChange={handleInputChange}
          />
          <Form.Check
            type="checkbox"
            name="shotgun"
            label="Shotgun Start?"
            checked={formData.shotgun}
            onChange={handleInputChange}
          />
        </Col>
      </Row>

      <br />
      <Button variant="primary" type="submit">
        Save Changes
      </Button>
    </Form>
  </Modal.Body>
</Modal>

        </>
      )}
      {/* Add league modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Create New League</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleAddLeague}>
      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>League Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={newLeagueData.name}
              onChange={handleNewInputChange}
              required
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              name="description"
              value={newLeagueData.description}
              onChange={handleNewInputChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <Form.Select
              name="course"
              value={newLeagueData.course}
              onChange={handleNewInputChange}
              required
            >
              <option value="">Select a course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Day</Form.Label>
            <Form.Control
              as="select"
              name="day"
              value={newLeagueData.day}
              onChange={handleNewInputChange}
              required
            >
              <option value="">Choose a day</option>
              {/* Populate days or use static values */}
              <option value="Monday">Monday</option>
              <option value="Tuesday">Tuesday</option>
              <option value="Wednesday">Wednesday</option>
              <option value="Thursday">Thursday</option>
              <option value="Friday">Friday</option>
              <option value="Saturday">Saturday</option>
              <option value="Sunday">Sunday</option>
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>
      <Row>
  <Col xs={12} md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Secretary Name</Form.Label>
      <Form.Control
        type="text"
        name="secretaryname"
        value={newLeagueData.secretaryname || ""}
        onChange={handleNewInputChange}
        required
      />
    </Form.Group>
  </Col>
  <Col xs={12} md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Secretary Phone</Form.Label>
      <Form.Control
        type="tel"
        name="secretaryphone"
        value={newLeagueData.secretaryphone || ""}
        onChange={handleNewInputChange}
        pattern="[0-9]*"
        inputMode="numeric"
        required
      />
    </Form.Group>
  </Col>
</Row>
<Row>
  <Col xs={12}>
    <Form.Group className="mb-3">
      <Form.Label>Secretary Email</Form.Label>
      <Form.Control
        type="email"
        name="secretaryemail"
        value={newLeagueData.secretaryemail || ""}
        onChange={handleNewInputChange}
        required
      />
    </Form.Group>
  </Col>
</Row>

      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              name="startdate"
              value={newLeagueData.startdate}
              onChange={handleNewInputChange}
              required
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
  <Form.Group className="mb-3">
    <Form.Label>Team Count</Form.Label>
    <Form.Select
      name="teamcount"
      value={newLeagueData.teamcount}
      onChange={handleNewInputChange}
      required
    >
      {Array.from({ length: 35 }, (_, i) => (
        <option key={i} value={i + 2}>
          {i + 2}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Start Time</Form.Label>
            <Form.Select
              name="starttime"
              value={newLeagueData.starttime}
              onChange={handleNewInputChange}
              required
            >
              {Array.from({ length: 21 }, (_, i) => {
                const hour = Math.floor(i / 2) + 8; // starts from 8 AM
                const minute = i % 2 === 0 ? "00" : "30";
                if (hour === 12) {
                  return <option key={i} value={`12:${minute} PM`}>{`12:${minute} PM`}</option>;
                }
                const displayHour = hour > 12 ? hour - 12 : hour;  // Convert to 12-hour format
                const period = hour >= 12 ? "PM" : "AM";
                return <option key={i} value={`${displayHour}:${minute} ${period}`}>{`${displayHour}:${minute} ${period}`}</option>;
              }).filter((_, i) => i <= 21)}  // Filters to include up to 6:00 PM as a start time
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="mb-3">
            <Form.Label>End Time</Form.Label>
            <Form.Select
              name="endtime"
              value={newLeagueData.endtime}
              onChange={handleNewInputChange}
              required
            >
              {Array.from({ length: 27 }, (_, i) => {
                const hour = Math.floor(i / 2) + 8; // starts from 8 AM
                const minute = i % 2 === 0 ? "00" : "30";
                if (hour === 12) {
                  return <option key={i} value={`12:${minute} PM`}>{`12:${minute} PM`}</option>;
                }
                const displayHour = hour > 12 ? hour - 12 : hour;  // Convert to 12-hour format
                const period = hour >= 12 ? "PM" : "AM";
                return <option key={i} value={`${displayHour}:${minute} ${period}`}>{`${displayHour}:${minute} ${period}`}</option>;
              }).filter((_, i) => i <= 27)}  // Filters to include up to 9:00 PM as an end time
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
  <Col xs={12} md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Handicap Percentage</Form.Label>
      <Form.Select
        name="hdcp_pct"
        value={newLeagueData.hdcp_pct}
        onChange={handleNewInputChange}
        required
      >
        <option value="">Select HDCP %</option>
        {Array.from({ length: 10 }, (_, i) => {
          const value = 55 + i * 5;
          return (
            <option key={value} value={value}>
              {value}%
            </option>
          );
        })}
      </Form.Select>
    </Form.Group>
  </Col>
  <Col xs={12} md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Max Handicap</Form.Label>
      <Form.Select
        name="maxHDCP"
        value={newLeagueData.maxHDCP}
        onChange={handleNewInputChange}
        required
      >
        <option value="">Select Max Handicap</option>
        {Array.from({ length: 21 }, (_, i) => (
          <option key={i} value={i + 5}>
            {i + 5}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  </Col>
</Row>

<Row>
  <Col xs={12} md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Max Handicap Up</Form.Label>
      <Form.Select
        name="hdcp_max_up"
        value={newLeagueData.hdcp_max_up}
        onChange={handleNewInputChange}
        required
      >
        <option value="">Select Max Up</option>
        {Array.from({ length: 5 }, (_, i) => (
          <option key={i} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  </Col>
  <Col xs={12} md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Max Handicap Down</Form.Label>
      <Form.Select
        name="hdcp_max_down"
        value={newLeagueData.hdcp_max_down}
        onChange={handleNewInputChange}
        required
      >
        <option value="">Select Max Down</option>
        {Array.from({ length: 5 }, (_, i) => (
          <option key={i} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  </Col>
</Row>

      <Row>
        <Col xs={12}>
          <Form.Check
            type="checkbox"
            name="isActive"
            label="Is Active?"
            checked={newLeagueData.isActive}
            onChange={handleNewInputChange}
          />
          <Form.Check
            type="checkbox"
            name="hasPosRnd"
            label="Has Position Round?"
            checked={newLeagueData.hasPosRnd}
            onChange={handleNewInputChange}
          />
          <Form.Check
            type="checkbox"
            name="finalfunday"
            label="Final Funday?"
            checked={newLeagueData.finalfunday}
            onChange={handleNewInputChange}
          />
          <Form.Check
            type="checkbox"
            name="shotgun"
            label="Shotgun Start?"
            checked={newLeagueData.shotgun}
            onChange={handleNewInputChange}
          />
        </Col>
      </Row>
      <br />
      <Button variant="success" type="submit">
        Create League
      </Button>
    </Form>
  </Modal.Body>
</Modal>

    </div>
  );
};

export default Dashboard;
